/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 控制级别
 */
let EnumWarningNotice = {
	Open: 					new EnumItem('打开', 1),
	Close: 					new EnumItem('关闭', 2),
	...enumMixn
}
export default EnumWarningNotice
